import { Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-black py-12" data-testid="footer">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-6 md:flex-row md:items-center lg:px-10">
        <div className="flex items-center gap-3">
          <img src="/assets/logo.jpg" alt="Gsoftware logo" className="h-10 w-10 rounded-sm object-cover" />
          <div>
            <p className="font-display text-sm font-bold tracking-widest text-[#00f0ff]">GSOFTWARE</p>
            <p className="font-mono-tech text-[10px] uppercase tracking-widest text-white/30">
              Build // Update // Manage
            </p>
          </div>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-3" data-testid="footer-links">
          {[
            ["Services", "#services"],
            ["Plans", "#plans"],
            ["Work", "#work"],
            ["Process", "#process"],
            ["Leadership", "#leadership"],
            ["Get Started", "#subscribe"],
          ].map(([label, href]) => (
            <a
              key={href}
              href={href}
              data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-mono-tech text-[11px] uppercase tracking-widest text-white/40 transition-colors duration-300 hover:text-[#00f0ff]"
            >
              {label}
            </a>
          ))}
        </nav>
        <div className="space-y-2">
          <a
            href="mailto:Damianoffice01@gmail.com"
            data-testid="footer-email-link"
            className="font-mono-tech flex items-center gap-2 text-[11px] uppercase tracking-widest text-white/40 transition-colors duration-300 hover:text-[#00f0ff]"
          >
            <Mail size={13} className="text-[#00f0ff]" /> Damianoffice01@gmail.com
          </a>
          <a
            href="tel:+17865643401"
            data-testid="footer-phone-link"
            className="font-mono-tech flex items-center gap-2 text-[11px] uppercase tracking-widest text-white/40 transition-colors duration-300 hover:text-[#00f0ff]"
          >
            <Phone size={13} className="text-[#ff003c]" /> (786) 564-3401
          </a>
          <p className="font-mono-tech pt-1 text-[10px] uppercase tracking-widest text-white/25">
            © {new Date().getFullYear()} Gsoftware. All systems operational.
          </p>
        </div>
      </div>
    </footer>
  );
}
